import * as Sentry from "@sentry/browser";

export * from "./tags/tags-from-config";
export * from "./tags/tags-from-request";
export * from "./tags/tags-from-session";

export namespace tags {
	export type Tags = {
		// Build.
		"zeller.build.sha"?: string;
		"zeller.build.version"?: string;

		// Session.
		"zeller.session.clientName"?: string;
		"zeller.session.clientVersion"?: string;
		"zeller.session.vendorName"?: string;
		"zeller.session.vendorApplicationName"?: string;
		"zeller.session.vendorApplicationVersion"?: string;
		"zeller.session.vendorDeviceType"?: string;

		// Headers.
		"zeller.request.deviceId"?: string;
		"zeller.request.deviceModel"?: string;
		"zeller.request.deviceSerial"?: string;

		// Headers (Inferred).
		"zeller.request.customerId"?: string;

		// Type.
		"zeller.request.queryType"?: string;

		// Configuration.
		"zeller.request.fullscreen"?: boolean;
		"zeller.request.theme"?: string;
		"zeller.request.terminalContact"?: boolean;
		"zeller.request.terminalReceipt"?: boolean;
		"zeller.request.terminalReceiptPrint"?: boolean;
		"zeller.request.terminalNote"?: boolean;
		"zeller.request.unattended"?: boolean;
		"zeller.request.virtualTerminal"?: boolean;
	};

	export type Options = {
		/**
		 * If `true` will apply tags to the global scope.
		 */
		global?: boolean;
	};
}

export function tags(tags: tags.Tags, options?: tags.Options): void {
	const scope = options?.global
		? Sentry.getGlobalScope()
		: Sentry.getIsolationScope();
	scope.setTags(tags);
	scope.setAttributes(tags);
}
